module.exports = __webpack_public_path__ + "img/Logo1.079ca37a.png";